<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <!-- Глобальные уведомления -->
    <NotificationContainer />

    <!-- Основной контент -->
    <router-view />
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import NotificationContainer from '@/components/ui/NotificationContainer.vue'

const authStore = useAuthStore()

// Проверяем авторизацию при загрузке приложения
onMounted(async () => {
  console.log('🔍 Проверка статуса авторизации...')
  await authStore.checkAuthStatus()
})
</script>

<style>
/* Глобальные стили уже подключены в main.css */
</style>